import React from 'react'

interface AppWrapperTitleProps {
  children: React.ReactNode
}

const AppWrapperTitle: React.FC<AppWrapperTitleProps> = ({ children }) => {
  return <div className="text-black font-semibold leading-tight text-base">{children}</div>
}

export default AppWrapperTitle
